/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankIdImage200,
  GetApiV1BankIdImage401,
  GetApiV1BankIdImage404,
  GetApiV1BankIdImage500,
  GetApiV1BankIdImagePathParams,
  GetApiV1BankIdImageQueryResponse,
} from "../../types/bankImagemController/GetApiV1BankIdImage.ts";

export const getApiV1BankIdImagePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BankIdImagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankIdImage200Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdImage200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankIdImage401Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdImage401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BankIdImage404Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdImage404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankIdImage500Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdImage500>;

export const getApiV1BankIdImageQueryResponseSchema = z.lazy(
  () => getApiV1BankIdImage200Schema,
) as unknown as ToZod<GetApiV1BankIdImageQueryResponse>;
